import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	weekOf: {
		id: 'software-cycle-time-breakdown-report.period-filter.week-of',
		defaultMessage: 'Week of {date}',
		description: 'Label in a select menu. e.g. Week of March 22',
	},
	weekCommencing: {
		id: 'software-cycle-time-breakdown-report.period-filter.week-commencing',
		defaultMessage: 'Week Commencing',
		description:
			'Category label in a select menu describing that the date options are for the start of the week',
	},
	helpTooltip: {
		id: 'software-cycle-time-breakdown-report.period-filter.help-tooltip',
		defaultMessage:
			'Identify progressively growing warning signs in your workflow by plotting weekly cycle time trends.',
		description: 'Tooltip explaining what this filter indicates',
	},
});
